import { Reminder } from "../../types/reminder";
import { generateAPI } from "../api.generator";

export const getAllWeddingReminders = generateAPI<
  any,
  Reminder[]
>("get", "reminder/all");
